import Big from 'big.js';
export function loyaltyReceiptTotals(discount, loyalty) {
    const pointsValue = loyalty?.native_redemption && loyalty.native_redemption.value > 0
        ? loyalty.native_redemption.value
        : 0;
    const giftValue = loyalty?.native_gift_card_redemption && loyalty.native_gift_card_redemption.value > 0
        ? loyalty.native_gift_card_redemption.value
        : 0;
    const goldValue = loyalty?.native_gold_discount && loyalty.native_gold_discount.value > 0
        ? loyalty.native_gold_discount.value
        : 0;
    const birthdayValue = loyalty?.native_birthday_discount && loyalty.native_birthday_discount.value > 0
        ? loyalty.native_birthday_discount.value
        : 0;
    let promo = Big(discount || 0).minus(pointsValue).minus(giftValue).minus(goldValue).minus(birthdayValue);
    if (promo.lt(0))
        promo = Big(0);
    return {
        promoDiscount: parseFloat(promo.toFixed(6)),
        points: pointsValue > 0 && loyalty?.native_redemption
            ? { points: loyalty.native_redemption.points, value: pointsValue }
            : null,
        giftCard: giftValue > 0 ? { value: giftValue } : null,
        gold: goldValue > 0 ? { value: goldValue } : null,
        birthday: birthdayValue > 0 ? { value: birthdayValue } : null,
    };
}
//# sourceMappingURL=loyalty-receipt-totals.js.map